﻿[<AutoOpen>]
module TypeFns

open Messages.Signup

module QueryFailed =

    let toString (err : MessageFailed) =
        match err with

        | ErrorResponse (EventStreamConcurrencyError) //tried to hit back over and over again to just refill and the guid didn't change/update. concurrent editing - refresh and try again
        | ErrorResponse (MessageDeserializationFailed  _) //bug on our part or page open and we updated or malicious behavior
        | ErrorResponse (EventSerializationFailed  _) //server problem hardware failed try again later contact support
        | ErrorResponse (ClientSearchPagingInvalid  _) -> //ui bug. contact support
            sprintf "There was an error trying to process your request. It could be that the application was updated. Try refreshing the page and retrying. If that doesn't work, then this is likely a bug and you should contact support. Tell them: %A" err


        | ErrorResponse (UserAccountCreationFailed  _) //try again later then contact support
        | ErrorResponse (SignupValidationError  _) -> //user correctable, but we should have caught it. UI problem
            sprintf "Your account could not be created in CQ. Please confirm information above then try again. If that does not work, then contact support. Tell them: %A" err

        | ErrorResponse (VendorUserAlreadyExists) //refresh then contact support
        | ErrorResponse (VendorAlreadyExists) -> //refresh then contact support
            sprintf "There was an error creating this account. Refresh the page, please contact support. Tell them: %A" err

        | ErrorResponse (UserAccountAreadyExistsInCognito)
        | ErrorResponse (UserAccountAlreadyExists) ->
            sprintf "Your user account seems to already exists in CQ. If your company has not already signed up, please contact support. Tell them: %A" err

        | ErrorResponse (EventStreamSaveFailed  _) //server side problem try again later then contact support
        | ErrorResponse (VendorStreamLoadFailed  _) //sever side error, try again later then contact support
        | ErrorResponse (VendorUserStreamLoadFailed  _) //sever side error, try again later then contact support
        | ErrorResponse (VendorClientLinkStreamLoadFailed _) //sever side error, try again later then contact support
        | ErrorResponse (DataLoadFailed  _) //searching server side problem, if persist contact support
        | ErrorResponse (VendorClientLinkAlreadyExists) //contact support
        | ErrorResponse (VendorEmailCheckFailed  _) -> //server side problem try again later
            sprintf "There seems to be a server issue. Please try again later. If this problem persist, contact support, and tell them: %A" err

        | ResponseParseFailed _ -> //refresh try again
            "Your request to the server failed. Try refreshing the page and trying again."

        | RequestFailed _ ->
            "The request to the server failed. It could be a temporary network interruption. Please try again later."

module JSONFailed =

    open Fable.React
    open Fable.React.Props
    open Ui.Language

    let toString (err: JSONFailed) =
        match err with
        | JSONRequestFailed _ ->
            "The request to the server failed. It could be a temporary network interruption. Try again later. Check the Console log!"
        | FailedToGetLanguageFile err ->
            sprintf "There was an error trying to process your request. It could be that the application was updated. Try refreshing the page and retrying. If that doesn't work, then this is likely a bug and you should contact support. Tell them: %A" err

    let errorMessage error =
        div [ Class "ui error message" ] [
            div [ Class "header" ] [
                str (Lang.getText Keys.LoadingDataFailed)
                i [ Class "frown outline icon" ] []
            ]
            p [] [ str (toString error) ]
        ]

    let handleJsonErrors jsonErrors =
        match jsonErrors with
        | None -> span [] []
        | Some error -> span [] [errorMessage error]